import FormControlLabel from '@mui/material/FormControlLabel';
import type { SxProps, Theme } from '@mui/material/styles';

import Toggle from 'shared/atoms/Toggle';
import T from 'shared/atoms/Typography';
import type { BackgroundThemes } from 'shared/const';
import theme from 'shared/themes/default';

import type { FormFieldProperties } from '../FormInput';

interface FormToggleProps {
  disabled?: boolean;
  id: string;
  handleChange?: (params: { name: string; value: unknown }) => void;
  label: string;
  name: string;
  properties?: Record<string, FormFieldProperties>;
  theme?: BackgroundThemes;
  values?: Record<string, unknown>;
}

const FormToggle = ({
  disabled: disabledProp,
  id,
  handleChange,
  label,
  name,
  properties = {},
  theme: themeLayout = 'dark',
  values = {},
}: FormToggleProps) => {
  const { disabled } = properties[name] || {};

  const onChangeHandler = (checked: boolean) => {
    handleChange?.({ name, value: checked });
  };

  const getColor = () => {
    if (disabledProp === undefined ? disabled : disabledProp) {
      return themeLayout === 'light'
        ? theme.palette.disabledLight
        : theme.palette.disabledDark;
    }
    return themeLayout === 'light'
      ? theme.palette.mainDark
      : theme.palette.lightPure;
  };

  return (
    <FormControlLabel
      control={
        <Toggle
          id={id}
          checked={!!values[name]} // TODO: Converting to boolean might be not needed if useForm handles it properly
          disabled={disabledProp === undefined ? disabled : disabledProp}
          onChange={onChangeHandler}
          theme={themeLayout}
        />
      }
      label={
        <T
          color={getColor()}
          component="span"
          fontWeight="medium"
          sx={{ marginLeft: theme.spacing.s } as SxProps<Theme>}
        >
          {label}
        </T>
      }
      sx={{ margin: 0 }}
    />
  );
};

export default FormToggle;
export type { FormToggleProps };
